import { Dropdown, MoreIconVertical } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { VisitHistoryWithConfidentialDetails } from '~libs.shared.visit';
import { useGetCurrentPractitionerGlobalState } from '~libs.shared.account';

import { useVisitReopenDropdownItem } from '../../appointment/table/cells/AdditionalOptions/useVisitReopenDropdownItem';

import { VisitSummaryPrintDropdownItem } from './VisitSummaryPrintDropdownItem';
import { PrintOrShareVisitDocumentsDropdownItem } from './PrintOrShareVisitDocumentsDropdownItem';

type VisitHistoryDropdownOptionsProps = {
   readonly visitHistory: VisitHistoryWithConfidentialDetails;
   readonly patientId: number;
};

export const VisitHistoryDropdownOptions = (props: VisitHistoryDropdownOptionsProps): JSX.Element => {
   const currentPractitioner = useGetCurrentPractitionerGlobalState();
   const { VisitReopenDropdownItem, visitReopenModal } = useVisitReopenDropdownItem({ visitId: props.visitHistory.id });

   const isOwnedByCurrentUser = props.visitHistory.ownedByCurrentUser;
   const isConfidentialVisit = props.visitHistory.confidentialityLevel === 'CONFIDENTIAL';
   const isCurrentPractitionerMonitored = currentPractitioner.confidentialAccessLevel === 'MONITORED';
   const isSummaryPrintable =
      Boolean(props.visitHistory.confidentialDetails.visitSummaryUrl) &&
      Boolean(props.visitHistory.confidentialDetails.visitSummaryMedicalDocumentId);

   const isMonitoredConfidentialAccessLevel =
      isCurrentPractitionerMonitored && isConfidentialVisit && !isOwnedByCurrentUser;

   return (
      <>
         <Dropdown
            triggerIcon={<MoreIconVertical />}
            triggerIconSuffixHidden
            testId={'visitHistoryDropdownOptions'}
            hideIfEmpty
         >
            {protectFeature(
               'searchingVisitOperations',
               <VisitReopenDropdownItem
                  patientId={props.patientId}
                  visitId={props.visitHistory.id}
                  ownedByCurrentUser={isOwnedByCurrentUser}
                  encounterMode={props.visitHistory.encounterMode}
               />,
               null
            )}

            {isConfidentialVisit && !isOwnedByCurrentUser
               ? null
               : protectFeature(
                    'searchingMedicalData',
                    <PrintOrShareVisitDocumentsDropdownItem
                       visitId={props.visitHistory.id}
                       patientId={props.patientId}
                    />,
                    null
                 )}

            {isSummaryPrintable ? (
               <VisitSummaryPrintDropdownItem
                  isMonitoredConfidentialAccessLevel={isMonitoredConfidentialAccessLevel}
                  visitSummaryMedicalDocumentId={
                     props.visitHistory.confidentialDetails.visitSummaryMedicalDocumentId as number
                  }
                  visitSummaryUrl={props.visitHistory.confidentialDetails.visitSummaryUrl as string}
                  requestToSummaryAccessStatus={props.visitHistory.requestToSummaryAccessStatus}
               />
            ) : null}
         </Dropdown>
         {visitReopenModal}
      </>
   );
};
